import { render, staticRenderFns } from "./JdhErrorMessage.vue?vue&type=template&id=0d6ebb4a&scoped=true&"
import script from "./JdhErrorMessage.vue?vue&type=script&lang=ts&"
export * from "./JdhErrorMessage.vue?vue&type=script&lang=ts&"
import style0 from "./JdhErrorMessage.vue?vue&type=style&index=0&id=0d6ebb4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6ebb4a",
  null
  
)

export default component.exports